module.exports = __webpack_public_path__ + "static/media/app-tracking.431bb10a.gif";